import { Button } from "@mui/material";
import UploadIcon from "@mui/icons-material/Upload";
import { useRef } from "react";
import { useIntl } from "react-intl";

export default function UploadField({ value, onChange, error }: any) {
  const intl = useIntl();
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      onChange(file);
    }
  };

  return (
    <>
      <input ref={inputRef} type="file" hidden onChange={handleFileChange} />
      <Button
        variant="contained"
        startIcon={<UploadIcon />}
        onClick={() => inputRef.current?.click()}
        color={error ? "error" : "primary"}
      >
        {value?.name || intl.formatMessage({ id: "chooseFile" })}
      </Button>
    </>
  );
}
